module.exports = __webpack_public_path__ + "media/images/sp/specials/common/special_c_02-7fabbdb9f96379069a8755132b415774.jpg";